import React from 'react';
import Edit from '../../rest/Edit';
import Form from '../components/Form';

const LogsEdit = props => (
  <Edit {...props} resource="logs">
    <Form />
  </Edit>
);

LogsEdit.propTypes = {};

export default LogsEdit;
